module.exports = __webpack_public_path__ + "img/icon-plus.e562c3c7.svg";